export interface PaddingValue {
    top: number
    right: number
    bottom: number
    left: number
}

interface PaddingFieldProps {
    value: PaddingValue
    onChange: (value: PaddingValue) => void
}

export default function PaddingField({ value, onChange }: PaddingFieldProps) {
    const v = value || { top: 0, right: 0, bottom: 0, left: 0 }

    const update = (key: keyof PaddingValue, raw: string) => {
        onChange({ ...v, [key]: parseInt(raw) || 0 })
    }

    return (
        <div>
            <div className="popup-field-label">Padding</div>
            <div className="popup-padding-field">
                {(['top', 'right', 'bottom', 'left'] as const).map(key => (
                    <div key={key}>
                        <div className="popup-field-sublabel">{key}</div>
                        <input
                            type="number"
                            min={0}
                            max={100}
                            value={v[key]}
                            onChange={e => update(key, e.target.value)}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export const defaultPadding: PaddingValue = { top: 0, right: 0, bottom: 0, left: 0 }

export function paddingToStyle(p: PaddingValue | undefined): string {
    const v = p ?? defaultPadding
    return `${v.top}px ${v.right}px ${v.bottom}px ${v.left}px`
}
